<template>
  <main class="content overview">
      <div v-if="loading" class="loading is-flex">
        <div class="spinner">
            <div class="mask">
                <div class="maskedCircle"></div>
            </div>
        </div>
      </div>
    
      <section class="heading has-padding">
        <h1>Neue Inspektion</h1>
      </section>

        <section class="form has-padding">
            <div class="field">
                <label class="label">Strecke</label>
                <div class="select">
                    <select v-model="selected_facility">
                        <option v-for="(facility, index) in facilities" 
                            :key="index" 
                            :value="facility.DB776_CODE">
                            {{facility.DB776_NAME}}
                        </option>
                    </select>
                    <i class="arrow down"></i>
                </div>
            </div>
            <div class="field">
                <label class="label">Ab Kilometer/ Abschnitt</label>
                <div class="control has-icons-right">
                    <input class="input" type="number" placeholder="z.B. 10 km" v-model="selected_km" @change="fetch_GET_Spots()">
                    <span class="icon is-right">
                        <i class="fas fa-envelope fa-xs"></i>
                    </span>
                </div>
            </div>
            <div class="field">
                <label class="label">Anlagen im Abschnitt</label>
                <div class="select">
                    <select v-model="selected_spot">
                      <option 
                        v-for="(spot, idx) in spots" 
                        :key="'s' + idx"
                        :value="spot"
                        >
                        {{ spot.ANL_BEZEICHNUNG }}
                      </option>
                    </select>
                    <i class="arrow down"></i>

                    <p v-if="!spots">Kein Abschnitt gewählt</p>
                    <p v-else-if="spots.length == 0">Keine Anlagen gefunden</p>
                    <p v-else-if="spots.length > 0 && !selected_spot">Bitte auswählen</p>
                </div>
            </div>
            <div v-if="show_ErrorDialog && !selected_spot" class="error-msg">
                <p><strong>Hinweis:</strong> Bitte wählen Sie eine Analge im gewünschten Streckenabschnitt aus.</p>
            </div>
      </section>

      <div @click="add_new_Inspection()" class="button is-primary is-flex">
          <h3>Neue Inspektion anlegen</h3>
      </div>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'inspektionanlage',
  data() {
    return {
        loading: false,
        facilities: null,
        selected_facility: 5014,
        selected_km: null,
        spots: null,
        selected_spot: null,
        error: null,
        show_ErrorDialog: false,
        is_Input_active: false
    }
  },
  created () {
      window.scrollTo(0, 0);
      this.fetch_GET_Facilities()
  },
  methods: {
    fetch_GET_Facilities () {
        this.error = this.facilities = null
        this.loading = true

        axios.get('https://www.lola-inspect.at/api/facilities/db776list/all', { headers: { Authorization: this.$store.state.authToken } })
        .then(function (response) {
            this.loading = false

            this.facilities = response.data
        }.bind(this))
        .catch(function (error) {
            this.error = error
        }.bind(this));
    },
    fetch_GET_Spots () {
        this.error = this.spots = null
        this.selected_spot = null

        axios.get('https://www.lola-inspect.at/api/facilities/many/' + this.selected_facility + '/' + this.selected_km, { headers: { Authorization: this.$store.state.authToken } })
        .then(function (response) {
            this.spots = response.data
        }.bind(this))
        .catch(function (error) {
            this.error = error
        }.bind(this));
    },
    add_new_Inspection () {
        if (this.selected_spot) {
            this.$store.state.facilities_inspection.ANL_ID = this.selected_spot.ANL_ID
            this.$store.state.facilities_inspection.ANL_BEZEICHNUNG = this.selected_spot.ANL_BEZEICHNUNG
            this.$store.state.facilities_inspection.DB776_CODE = this.selected_spot.DB776_CODE

            this.$store.state.facilities_inspection.userName = this.$store.state.user.userName
            this.$store.state.facilities_inspection.userFirstname = this.$store.state.user.firstName
            this.$store.state.facilities_inspection.userLastname = this.$store.state.user.lastName

            this.$store.state.facilities_inspection.inspectForm = this.selected_spot.UNTERSUCHUNGSPROTOKOLL

            if (this.selected_spot.UNTERSUCHUNGSPROTOKOLL === 'mauer') {
                this.$router.push('inspektion_mauer');
            } else if (this.selected_spot.UNTERSUCHUNGSPROTOKOLL === 'durchlass') {
                this.$router.push('inspektion_durchlass');
            }
        } else {
            this.show_ErrorDialog = true
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.select p {
    font-size: 1rem;
    position: absolute;
    top: calc(50% - 0.7rem);
    left: 1rem;
    opacity: 0.75;
    pointer-events: none;
}
@media all and (min-width: 640px) and (max-width: 1100px) {

}

@media (min-width: 780px) {
  .has-padding {
    max-width: var(--maxWidth);
    margin: 0 auto;
  }
}
</style>